import { isValidElement } from 'react';
import { hexToRgba } from '../hex-to-rgba';
import { COLORS } from '../../constants/styles';

export const OverrideReactSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 35,
    borderColor: hexToRgba(COLORS.bluePrimary, 0.1),
    borderRadius: 2,
    boxShadow: state.isFocused
      ? `0 0 0 1px ${hexToRgba(COLORS.fontPrimary, 0.5)}`
      : 'none',
    '&:hover': { borderColor: hexToRgba(COLORS.bluePrimary, 0.1) },
  }),
  placeholder: base => ({
    ...base,
    color: hexToRgba(COLORS.fontPrimary, 0.6),
    fontSize: 14,
  }),
  dropdownIndicator: base => ({
    ...base,
    padding: 6,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: base => ({ ...base, zIndex: 3 }),
  option: base => ({
    ...base,
    fontSize: 14,
  }),
  input: base => ({
    ...base,
    margin: 0,
  }),
  valueContainer: base => ({
  ...base,
  padding: '2px 0px 2px 6px',
}),
  singleValue: (base, state) => {
    const hasComplexLabel = isValidElement(state.data && state.data.label);
    return {
      ...base,
      fontSize: 14,
      position: 'static',
      transform: 'none',
      whiteSpace: 'normal',
      ...(hasComplexLabel && { padding: '10px 0}' }),
    };
  },
};



// WEBPACK FOOTER //
// ./src/utils/select/override-react-select-styles.js